import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { InterceptService, StorageService } from './shared/services';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthGuard } from './shared/guard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModalComponent } from './common/modals/common-modal/common-modal.component';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { DataTablesModule } from 'angular-datatables';
import { DeleteModalComponent } from './shared/modals/delete-modal/delete-modal.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { OtpVerifyComponent } from './auth/otp-verify/otp-verify/otp-verify.component';
import { DateFormatterService } from './shared/services/date-formatter.service';
import { RouterModule } from '@angular/router';
import { CancellationModalComponent } from './shared/modals/delete-modal/cancellation-modal/cancellation-modal.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { DeactivationComponent } from './shared/modals/delete-modal/deactivation/deactivation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { provideAteEditor } from '@flogeez/angular-tiptap-editor';



@NgModule({
  declarations: [
    AppComponent,
    DeleteModalComponent,
    CommonModalComponent,
    OtpVerifyComponent,
    CancellationModalComponent,
    DeactivationComponent



  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    RouterModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxUiLoaderModule,
    CommonModule,
   
   
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [NgxSpinnerModule],
  providers: [
    AuthGuard,
    StorageService,
    CookieService,
      provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
    { provide: NgbDateParserFormatter, useClass: DateFormatterService },
    provideAteEditor()
  ],
  bootstrap: [AppComponent],

})
export class AppModule { }
